module.exports = __webpack_public_path__ + "static/media/brand-loader.684b74b0.gif";